import { IVehicleProps } from 'utils/type'
import { CarName } from './proposalElements'

interface IInputProps {
  vehicleType: string
  vehicle: IVehicleProps
}
const CarDescriptionBlock = (data: IInputProps) => {
  return data.vehicle ? (
    <CarName>
      {data.vehicle.id && (
        <span>
          <span>
            {data.vehicle.year} {data.vehicle.make}{' '}
          </span>
          <span>{data.vehicle.family}</span>
        </span>
      )}
    </CarName>
  ) : (
    <></>
  )
}

export default CarDescriptionBlock
